import { Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { WhTransferOrderProductModel } from 'src/app/models/loads/wh-transfer-order-product.model';
import { WhTransferOrderModel } from 'src/app/models/loads/wh-transfer-order.model';
import { SimpleEntity } from 'src/app/models/simple-entity.model';
import { LoadsService } from 'src/app/services/loads/loads.service';
import { UserService } from 'src/app/services/user/user.service';
import { BaseFormComponentComponent } from 'src/app/shared/base-form-component/base-form-component.component';

@Component({
  selector: 'app-stock-tranfer-warehouses',
  templateUrl: './stock-tranfer-warehouses.component.html',
  styleUrls: ['./stock-tranfer-warehouses.component.scss'],
  encapsulation: ViewEncapsulation.None
})


export class StockTranferWarehousesComponent extends BaseFormComponentComponent implements OnInit {

    userCompany: SimpleEntity = null;
    whTransferOrder: WhTransferOrderModel = new WhTransferOrderModel();


    constructor(protected injector: Injector, private loadService: LoadsService, private userService: UserService) {
      super(injector);
    }

    ngOnInit(): void {
      this.userCompany = this.userService.getCompany();
    }

    onWarehousesChanged() {
      if((this.whTransferOrder.newWarehouse &&  this.whTransferOrder.warehouse) && this.whTransferOrder.warehouse.id == this.whTransferOrder.newWarehouse.id) {
        setTimeout(() => this.whTransferOrder.newWarehouse = null, 300);
        this.showMessage('warn', 'Uyarı', 'Talep yapılan depo ile aktarım yapılacak depo aynı olamaz!');
      }
    }

    addProduct() {
      this.whTransferOrder.details.push(new WhTransferOrderProductModel())
    }

    removeProduct(index) {
      console.log(this.whTransferOrder.details, "products", index)
      if(this.whTransferOrder.details[index].id) {
        // Todo delete query
      }

      this.whTransferOrder.details.splice(index, 1);

    }

    async save(form) {
      if(!this.isValid()) return;

      if(this.whTransferOrder.details.length == 0) {
        this.showMessage('warn', 'Uyarı', 'Lütfen ürün seçiniz miktarı belirtiniz.');
        return;
      }

      console.log(this.whTransferOrder)
      this.isLoading = true;

      this.loadService.createWhTransfer(this.whTransferOrder).subscribe(() => {
        this.isLoading = false;
        this.showMessage('success', '', 'Kayıt oluşturuldu.');
      }, () => this.isLoading = false);

    }


}

